import { useEffect, useState } from "react";

/**
 * Returns `value` but only after it has remained unchanged for `delayMs`.
 * Intermediate updates are dropped, so expensive derived work (filtering,
 * fetching, rendering) only runs against the settled value.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return debouncedValue;
}
